// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AJmO","top":"styles_top__2a2j-","left":"styles_left__2zwhe","description":"styles_description__GLDc4"};